import reviewActionTypes from '../actionTypes'

const initialState = {
  data: [],
  metrics: {
    total_reviews: 0,
    average_rating: 0,
    response_rate: 0,
    review_rate: 0
  },
  totalPages: 1,
  params: {},
  shareData: {} // A
}

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case reviewActionTypes.GET_REVIEWS:
      return {
        ...state,
        data: action.payload.data,
        totalPages: action.payload.totalPages,
        params: action.payload.params
        // Don't touch metrics here
      }

    case reviewActionTypes.SHARE_REVIEW:
      return {
        ...state,
        shareData: {
          ...state.shareData,
          [action.payload.id]: {
            platform: action.payload.platform,
            share_url: action.payload.shareData.share_url,
            image_url: action.payload.shareData.image_url,
            social_links: action.payload.shareData.social_links,
            share_text: action.payload.shareData.share_text,
            hashtags: action.payload.shareData.hashtags,
            shared_at: new Date().toISOString()
          }
        }
      }

    case reviewActionTypes.RESPOND_TO_REVIEW:
      return {
        ...state,
        data: state.data.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              response: action.payload.message,
              responded_at: new Date().toISOString()
            }
          }
          return item
        })
      }

    case reviewActionTypes.GET_STATS:
      return {
        ...state,
        metrics: action.payload.metrics
      }
    default:
      return state
  }
}

export default reviewsReducer

